import menu from './enCN/menu';
import daily from './enCN/daily';
import active from './enCN/active';
import churn from './enCN/churn';
import common from './enCN/common';
import header from './enCN/header';
import ltv from './enCN/ltv';
import monthly from './enCN/monthly';
import realtime_revenue from './enCN/realtime_revenue';
import realtime_users from './enCN/realtime_users';
import register from './enCN/register';
import retention from './enCN/retention';
import returns from './enCN/return';
import revenue from './enCN/revenue';
import ua_no_spend from './enCN/ua_no_spend';
import ua from './enCN/ua';
import weekliy from './enCN/weekliy';
import filter from './enCN/filter';
import overview from './enCN/overview';
import trackingDayComponent from './enCN/trackingDayComponent';
import gameSelector from './enCN/gameSelector';
import selectorMultipleComponent from './enCN/selectorMultipleComponent';
import regionSelectorComponent from './enCN/regionSelectorComponent';
import dateComparison from './enCN/date_comparison';
import EventComparison from './enCN/event_comparison';
import countryComparison from './enCN/country_comparison';
import commonOptions from './enCN/common_options';
import metricsSelect from './enCN/metricsSelect';
import showMoreStatistics from './enCN/showMoreStatistics';
import refreshComponent from './enCN/refreshComponent';
import downloadFormatModalComponent from './enCN/downloadFormatModalComponent';
import dailyByTimezone from './enCN/dailyByTimezone';
import newUsersRetentionByTimezone from './enCN/newUsersRetentionByTimezone';
import metricsSetting from './enCN/metricsSetting';
import competitor from './enCN/competitor';
import eventAnalysis from './enCN/eventAnalysis';
import errorCode from './enCN/errorCode';
import subscribe from './enCN/subscribe';
import userGuid from './enCN/user_guide';
import funnel from './enCN/funnel';
import pcConsoleRevenue from './enCN/pcConsoleRevenue';
import poeFilter from './enCN/poeFilter';
import wow from './enCN/wow';
import benchmark from './enCN/benchmark';
import sth from './enCN/sth';
import secureIframeRender from './enCN/secureIframeRender';

export default {
  ...daily,
  ...active,
  ...churn,
  ...common,
  ...header,
  ...ltv,
  ...monthly,
  ...realtime_revenue,
  ...realtime_users,
  ...register,
  ...retention,
  ...returns,
  ...revenue,
  ...ua_no_spend,
  ...ua,
  ...weekliy,
  ...filter,
  ...overview,
  ...trackingDayComponent,
  ...gameSelector,
  ...selectorMultipleComponent,
  ...regionSelectorComponent,
  ...menu,
  ...dateComparison,
  ...EventComparison,
  ...commonOptions,
  ...metricsSelect,
  ...showMoreStatistics,
  ...countryComparison,
  ...refreshComponent,
  ...downloadFormatModalComponent,
  ...dailyByTimezone,
  ...newUsersRetentionByTimezone,
  ...metricsSetting,
  ...competitor,
  ...eventAnalysis,
  ...errorCode,
  ...subscribe,
  ...userGuid,
  ...funnel,
  ...pcConsoleRevenue,
  ...poeFilter,
  ...wow,
  ...benchmark,
  ...sth,
  ...secureIframeRender,
};
